import { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/toaster";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import { LanguageProvider } from "@/lib/useLanguage";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// Eagerly load the home page for best LCP
import Home from "./pages/Home";

// Lazy load all other pages to reduce initial bundle size
const Quote = lazy(() => import("./pages/Quote"));
const GetQuote = lazy(() => import("./pages/GetQuote"));
const Documents = lazy(() => import("./pages/Documents"));
const UDI = lazy(() => import("./pages/UDI"));
const Retirement = lazy(() => import("./pages/Retirement"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const About = lazy(() => import("./pages/About"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const Admin = lazy(() => import("./pages/Admin"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogArticle = lazy(() => import("./pages/BlogArticle"));
const TranslationService = lazy(() => import("./pages/TranslationService"));

const queryClient = new QueryClient();

const LegacyContactWidget = () => {
  const { pathname } = useLocation();
  return pathname === "/" || pathname === "/get-quote" ? null : <WhatsAppFAB />;
};

// Minimal loading fallback to avoid layout shift
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="animate-pulse text-muted-foreground">Loading...</div>
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/get-quote" element={<GetQuote />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/udi" element={<UDI />} />
              <Route path="/retirement" element={<Retirement />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/about" element={<About />} />
              <Route path="/admin-login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/thai-ekteskap-skilsmisse-oversettelse" element={<TranslationService path="/thai-ekteskap-skilsmisse-oversettelse" />} />
              <Route path="/oversette-norske-dokumenter-til-thai" element={<TranslationService path="/oversette-norske-dokumenter-til-thai" />} />
              <Route path="/thai-familieinnvandring-dokumenter" element={<TranslationService path="/thai-familieinnvandring-dokumenter" />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <LegacyContactWidget />
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
